<template>
    <div class="FM_agentwithdrawalInfo">
        <!-- 提现详情/审核 -->
        <el-dialog
            ref="terminalAudit"
            :visible="infoIsShow"
            @close="handleClose"
            :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <div class="title">银行信息</div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="labels">持卡人姓名：</span>
                        <span>{{dialogData.data.real_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">银行名称：</span>
                        <span>{{resData.bank_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">银行卡号：</span>
                        <span>{{resData.bank_code}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">预留手机号：</span>
                        <span>{{resData.phone}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">开户所在地：</span>
                        <span>{{resData.bank_prov}}-{{resData.bank_city}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">开户支行：</span>
                        <span>{{resData.branch_bank}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">联行号：</span>
                        <span>{{resData.line_num}}</span>
                    </el-col>
                </el-row>
                <el-form
                    :model="auditForm"
                    label-position="top"
                    label-width="80px"
                >
                    <div class="title">说明/备注</div>
                    <el-input v-model="auditForm.content" placeholder="请输入说明/备注"></el-input>
                    <div class="title">打款金额<span style="color:red">[单位:元]</span></div>
                    <el-input v-model="auditForm.amount" placeholder="请输入打款金额" style="width: 130px;"></el-input>
                    <div class="title">选择银行卡</div>
                    <el-select
                    size="medium"
                    v-model="auditForm.bank_id"
                    style="width:405px"
                    placeholder="请选择提现银行卡"
                    >
                        <el-option
                            v-for="(item,index) in selectbank"
                            :key="index"
                            :label="item.bank_name+' | '+item.bank_code"
                            :value="item.bank_id"
                        ></el-option>
                    </el-select>
                    <div class="audit">
                        <div class="title">结算方式</div>
                            <el-radio  v-model="auditForm.atype" :label="0" @change="typeChange(0)">分润账户(0)[余额:¥{{balance.payment_balance0}}]</el-radio>
                            <el-radio  v-model="auditForm.atype" :label="1" @change="typeChange(1)">基本账户(1)[余额:¥{{balance.payment_balance1}}]</el-radio>
                    </div>
                    <div class="title">验证码</div>
                    <el-input style="width:250px;float:left" v-model="auditForm.code" placeholder="请输入验证码,将发送至[18662252099]" ></el-input>
                    <el-col :span="5">
                        <div style="width:100px">
                            <el-button
                                type="primary"
                                style="min-width:100%;font-size: 12px;"
                                @click="sendCode"
                                :disabled="codeButton"
                            >{{codeText}}</el-button>
                        </div>
                    </el-col>
                </el-form>
                <div style="margin-top:60px">
                    <el-button
                        @click="submit"
                        type="primary"
                        size="medium"
                        style="font-size:12px"
                        :loading="loading"
                    >确 定</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "FM_agentwithdrawalInfo",
    props: {
        infoIsShow: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        },
    },

    data() {
        return {
            balance: {},//账户余额
            selectbank:{},
            codeButton: false,
            codeText: '发送验证码',
            auditForm: {
                atype: 0,
                amount:"",
                content:"",
                code:"",
                bank_acc_name:"",
                bank_acc_no:"",
                bank_acc_type:"",
                bank_name:"",
                user_id:this.dialogData.data.id,
            },
            resData: {},
            loading: false
        }
    },
    mounted() {
        this.$api.post('organization/getBalance', {}, res => {
            if (res.code == 0) {
                this.balance = res.data;
            } else {
                this.$message.error(res.msg);
                this.refLoading = false;
            }
        });
        this.$api.post('user/bank_lists_by_user_id', {user_id:this.dialogData.data.id}, res => {
            if (res.code == 0) {
                this.selectbank = res.data;
                this.auditForm.bank_id=res.data[0].bank_id;
                this.getbanks(res.data[0].id);
            } else {
                this.$message.error(res.msg);
            }
        });
    },
    methods: {
        getbanks(bankId) { //获取支付方式
            this.$api.post('user/bank_info', { bank_id: bankId }, res => { //初始化
                if (res.code == 0) {
                    this.resData = res.data[0];
                    this.auditForm.bank_acc_name=this.dialogData.data.real_name;
                    this.auditForm.bank_acc_no=res.data[0].bank_code;
                    this.auditForm.bank_acc_type=res.data[0].account_type;
                    this.auditForm.bank_name=res.data[0].bank_name;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        submit() { //提交
            // this.loading = true; //防重复
            this.$api.post('user/deal_withdraw_audit', this.auditForm, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message.success({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                        onClose() {
                            that.handleClose(1);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        },
        typeChange(val) { //监听radio
            this.auditForm.atype = val;
        },
        sendCode() { //发送验证码
            this.codeButton = true;
            let that = this;
            let timer = null;
            let count = 60;
            timer = setInterval(() => {
                count--;
                this.codeText = count;
                if (count == 0) {
                    clearInterval(timer);
                    this.codeText = '发送验证码';
                    this.codeButton = false;
                }
            }, 1000);
            this.$api.post('send/sms', { phone: "18662252099", type: 1 }, res => { //发送
                if (res.code == 0) {
                    this.$message.success(res.msg);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg,
                        duration: 2000,
                        onClose() { //错误提示信息
                            clearInterval(timer);
                            that.codeButton = false; //解开按钮
                            that.codeText = '发送验证码'; //重置按钮内容
                        }
                    });

                }
            })
        },
        handleClose(ref) {
            this.$emit('infoClose', ref);
        }
    },
};
</script>

<style lang="scss" scope>
.FM_agentwithdrawalInfo {
    * {
        font-size: 12px;
    }
    .labels {
        font-weight: 700;
    }
    .desc {
        border: 1px solid #d0d0d0;
        background-color: #ebeef5;
        padding: 3px;
        line-height: 20px;
        margin-top: 5px;
    }
    .title {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
        .el-button--text {
            color: #303133;
            font-size: 13px;
            font-weight: 700;
        }
    }
    .el-input__inner,
    ::v-deep .el-radio__label {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
        ::v-deep .el-form-item__label {
            padding: 0;
            font-weight: 700;
            font-size: 12px;
        }
        ::v-deep .el-form-item__content {
            line-height: 0;
        }
    }
    ::v-deep .el-checkbox__label {
        font-size: 12px;
    }
    .el-row {
        margin: 10px 0;
        &:last-child {
            margin-bottom: 0;
        }
        .el-col {
            margin: 10px 0;
        }
    }
}
</style>
